'use strict';

/** @type {import('./floor')} */
module.exports = Math.floor;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/math-intrinsics@1.1.0/~/math-intrinsics/floor.js
// module id = 651
// module chunks = 0